import React from 'react';
import { NavLink } from 'react-router-dom';

import benefits from '../assets/img/benefits.png';

const OurBenefits = () => {
    return (
        <section className="benefits-sec">
            <div className="container c_container">
                <div className="row align-items-end">
                    <div className="col-lg-7">
                        <div className="benefits-left" data-aos="fade-up">
                            <img src={benefits} alt="" className="w-100" />
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="benefits-right">
                            <h6 className="small-heading" data-aos="fade-up">Our Benefits</h6>
                            <h3 className="heading-gradient" data-aos="fade-up">Start Preparing for Your Next test!</h3>
                            <ul className="benefits-List">
                                <li data-aos="fade-up">Quicker access to diagnostics for your residents/patients</li>
                                <li data-aos="fade-up">A material reduction in Emergency Department attendances and hospital transfers for your residents/ patients</li>
                                <li data-aos="fade-up">Better clinical outcomes through earlier diagnosis allowing a treatment plan to be put in place without requiring a trip to the hospital</li>
                                <li data-aos="fade-up">Improved patient and clinical experience</li>
                                <li data-aos="fade-up">A differentiator for nursing homes, primary centres, events companies and other healthcare facilities</li>
                            </ul>
                            <NavLink to="#" className="btn custom-btn2" data-aos="fade-up">Get Started</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurBenefits;